import { clientLog } from 'nike-ui/src/common/logging/logs';
import { BotDefenceLog } from 'nike-ui/src/common/logging/BotDefenceLog';
import { getProperty } from '@/common/oldMobile';
import { createBotDefence } from '@/botdefence/tool/botDefence';

const isBotDefenceActive = getProperty('__b_d_A') === true;

export const makeBotDefence = challengeEndpoint => {
    if (!isBotDefenceActive) {
        return {
            toggleLoop: () => {},
            forceChallenge: () => Promise.reject('not active ' + challengeEndpoint),
            getStatus: () => 'not active'
        };
    }

    return createBotDefence({
        challengeEndpoint: challengeEndpoint,
        onDone: function(duration) {
            clientLog(
                BotDefenceLog({
                    message: 'BD challenge done.',
                    data: { duration, endpoint: challengeEndpoint }
                })
            );
        },
        onStart: function() {
            clientLog(BotDefenceLog({ message: 'BD challenge started.', data: { endpoint: challengeEndpoint } }));
        },
        onTimeout: function() {
            clientLog(BotDefenceLog({ message: 'BD challenge timeout.', data: { endpoint: challengeEndpoint } }));
        }
    });
};
